export class CmpAlertModalObject {
    show = false;
    showModalClose = true;
    modalCloseAction = '';
    title = '';
    content = '';
    directContent = false;
    buttonName = 'Ok';
    buttonAction = '';
    secondButtonName = '';
    secondButtonAction = '';
    buttonClassName = '';
    secondButtonClassName = '';
    buttonColSize = '';
    titleClass = '';
    hideFirstButton = false;
}

export class CmpInlineAlertModalObject {
    show = false;
    content = '';
    alertIcon = '';
    alertType = '';
}
